module.exports = __webpack_public_path__ + "static/corporate-office-bg-overlay-cb598170e2fa93d81c414e31aa9acbab.jpg";